import { Injectable } from '@angular/core';
import { NgxRolesService } from 'ngx-permissions';

import { AuthService } from '@services/api/auth.service';

@Injectable()
export class AppConfigService {

  constructor(private authService: AuthService, private rolesService: NgxRolesService) {}

  load() {
    this.rolesService  
    .addRoles({
      'Empleado': () => {
        return !this.authService.isAdmin;
      },      
      'SuperAdmin': () => {
        return this.authService.isAdmin;
      }
    });  
  }

}
